export default "__VITE_ASSET__CRTt27Ak__"